import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMultiMedia: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMultiMedia"><Path fillRule="evenodd" clipRule="evenodd" d="M2 2H16V8H22V22H8V16H2V2ZM8 10.4319L6 9.09861L3.5 10.7653V3.5H14.5V8H8V10.4319ZM5 6.25C5 5.55964 5.55964 5 6.25 5C6.94036 5 7.5 5.55964 7.5 6.25C7.5 6.94036 6.94036 7.5 6.25 7.5C5.55964 7.5 5 6.94036 5 6.25ZM13 11.9546L17.9263 15L13 18.0454V11.9546Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMultiMedia;
